import { Places } from '../../../Constants'
import AnaliseKeys from '../analise.keys'

export class AnaliseFormKeys extends AnaliseKeys {
    get place() {
        return Places.analiseForm
    }
}
export default AnaliseFormKeys